

module.exports = __webpack_require__.stylable.create(
    "emptyState997216530",
    {"classes":{"root":"emptyState997216530__root","rootLiveSite":"emptyState997216530__rootLiveSite","icon":"emptyState997216530__icon"},"vars":{},"stVars":{"IconColor":"\"color(color-5)\""},"keyframes":{}},
    "",
    11,
    "emptyState997216530",
    null
);
